import React from "react";
import {
  Box,
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";

interface CustomSelectProps {
  options: string[];
  value: string | string[]; // 🔥 Accepts both string & array
  onChange: (value: string | string[]) => void; // 🔥 Handles both types
  multiple?: boolean;
  placeholder?: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  value,
  onChange,
  multiple = false,
  placeholder = "Select",
}) => {
  const handleChange = (event: SelectChangeEvent<string | string[]>) => {
    let newValue: string | string[];

    if (multiple) {
      newValue = typeof event.target.value === "string" ? [event.target.value] : event.target.value;
    } else {
      newValue = event.target.value as string; // ✅ Ensures a string for single select
    }

    onChange(newValue); // ✅ Fix: Properly updates state
  };

  return (
    <Select
      multiple={multiple}
      value={value} // ✅ Fix: Proper value binding
      onChange={handleChange}
      IconComponent={ArrowDropDown}
      displayEmpty
      renderValue={(selected) => {
        if (!selected || (Array.isArray(selected) && selected.length === 0)) {
          return <Box sx={{ color: "rgba(255,255,255,0.5)" }}>{placeholder}</Box>;
        }
        return Array.isArray(selected) ? selected.join(", ") : selected; // ✅ Fix: Properly show selected value
      }}
      sx={{
        width: "100%",
        height: "42px",
        backgroundColor: "#000000",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        borderRadius: "3px",
        color: "#FFFFFF",
        fontSize: "14px",
        fontFamily: "Arial, sans-serif",
        "& .MuiSelect-select": { color: "#FFFFFF" },
        "& .MuiSelect-icon": { color: "#FFFFFF" },
        "&:hover": { borderColor: "#BA6F2A" },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            backgroundColor: "#121212",
            color: "#FFFFFF",
            maxHeight: 224,
            width: 250,
            borderRadius: "3px",
            "& .MuiMenuItem-root": {
              color: "#FFFFFF",
              "&:hover": { backgroundColor: "#333333" },
            },
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {multiple && (
            <Checkbox
              checked={Array.isArray(value) ? value.includes(option) : value === option}
              sx={{
          color: "#FFFFFF",
          "&.Mui-checked": { color: "#00E676" },
              }}
            />
          )}
          <ListItemText
            primary={
              option === "Luxor Exclusive"
          ? "Luxor Exclusive (Chanda Nagar)"
          : option === "Luxuria"
          ? "Luxuria (Kondapur)"
          : option
            }
            sx={{ color: "#FFFFFF" }}
          />
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomSelect;
